module.exports = __webpack_public_path__ + "img/bg-head-large.a2f0a024.png";